import { useAuth } from '@shared/auth';
import {
  ConfirmationModal,
  ListItemButton,
  ListItemIcon,
  LogoutRoundedIcon,
  Text,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { TooltipMenu } from '../../components';

interface LogoutMenuItemProps {
  minified?: boolean;
}

export default function LogoutMenuItem(props: Readonly<LogoutMenuItemProps>) {
  const { minified: isMinified = false } = props;

  const [isOpen, { open, close }] = useDisclosure(false);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    close();
  };

  return (
    <>
      <TooltipMenu title={isMinified ? 'ออกจากระบบ' : ''}>
        <ListItemButton component='li' onClick={open}>
          <ListItemIcon>
            <LogoutRoundedIcon />
          </ListItemIcon>
          <Text>ออกจากระบบ</Text>
        </ListItemButton>
      </TooltipMenu>
      <ConfirmationModal
        open={isOpen}
        title='ออกจากระบบ'
        content={<Text>คุณต้องการออกจากระบบใช่หรือไม่?</Text>}
        acceptText='ยืนยัน'
        discardText='ยกเลิก'
        onAccept={handleLogout}
        onDiscard={close}
      />
    </>
  );
}
